import React from 'react'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import { useEffect } from 'react';
import "../styles/website.css"
import { Link, useNavigate } from 'react-router-dom';
import FAQ from '../components/Faqs';
import testimonial from "../assets/img/testimonial/carman.png"
import testimonial1 from "../assets/img/testimonial/tw.jpg"
import testimonial2 from "../assets/img/testimonial/tk.jpg"
import testimonial3 from "../assets/img/testimonial/tm.jpg"
import { RiDoubleQuotesL } from "react-icons/ri";
import { RiDoubleQuotesR } from "react-icons/ri";
import { GoDash } from "react-icons/go";
import CaseStudy from '../components/CaseStudy';
import heroImg from "../assets/img/r1.avif"
import "../styles/digitalMarketing.css"
import { IoIosArrowRoundDown } from "react-icons/io";
import servicesImg from "../assets/img/s.jpg"
import ServicesCards from '../components/ServicesCards';
import CaseStudyGallery from '../components/CaseStudyGallery';
import AboutSection from '../components/AboutSection';
import { Banner } from '../components/Banner';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const PaidMediaPerfomance = () => {

 
  

    const navigate = useNavigate();
  
  
  const handleContactBtn = () => {
    navigate("/get-in-touch")
  }
  

  return (
    <>
<section className="website-wrapper">
    

 <Nav/>

  <Banner/>
   
 <AboutSection/>
   
  <CaseStudyGallery/>

  

  <FAQ/>




</section>

<section className="client-testimonials">
  <h3>
    What our clients have said <br />
    <span>about our work</span>
  </h3>

  <div className="testimonial-cards">
    <div className="testimonial-card">
      <p className="quote">
        “This was our first time running Facebook ads, and they made the entire process super smooth. From setting up the campaign to targeting the right audience, everything was handled professionally.”
      </p>
      <div className="client-info">
        <img
          src={testimonial}
          alt="Tayla Ahrens"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Joram Ndung'u</p>
          <p className="client-title">Managing Director — Carman Autos</p>
        </div>
      </div>
    </div>

    <div className="testimonial-card">
      <p className="quote">
        “Excellent communication and precise targeting. They refined my Facebook Ads audience and creatives perfectly, and I finally started getting real engagement. Impressive work!”
      </p>
      <div className="client-info">
        <img
          src={testimonial1}
          alt="Will Perrin"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Peris Wamboi</p>
          <p className="client-title">Director — Jijenge Agency</p>
        </div>
      </div>
    </div>

 <div className="testimonial-card">
  <p className="quote">
    “The team is highly professional and deeply knowledgeable in Google Ads and
    performance marketing. Their strategic approach helped take our campaign to
    the next level. "
   </p>

  <div className="client-info">
    <img
      src={testimonial2}
      alt="Tayla Ahrens"
      className="client-avatar"
    />
    <div>
      <p className="client-name">Tayla Kerubo</p>
      <p className="client-title">
        Marketing Manager — C & M Beauty  
      </p>
    </div>
  </div>
</div>


    <div className="testimonial-card">
      <p className="quote">
        “The Facebook Ads campaign delivered amazing results for my business. Every step, from keyword research to ad creation, was handled with great expertise."
       </p>
      <div className="client-info">
        <img
           src={testimonial3}
          alt="Will Perrin"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Martin Musee</p>
          <p className="client-title">Director — Musee Tailors</p>
        </div>
      </div>
    </div>
  </div>
</section>


<section className="booking-wrapper">
  <div className="booking-content">
    <h3>Let's get to work</h3>
    <p>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>

<Footer/>
</>

  )
}

export default PaidMediaPerfomance